import React, { useState, useEffect } from "react";
import { Link, useNavigate, useLocation, NavLink } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import { authActions } from "../../redux/store";
import toast from "react-hot-toast";
// import TokenValidator from "../../fetchdata/TokenValidator";
import Cart from "./Cart";
import { useBlogContext } from "../../fetchdata/BlogContext";
import $ from "jquery";
import { Helmet } from "react-helmet";

import getCookie from "../../helper/getCookie";
import eraseCookie from "../../helper/eraseCookie";
import CreateSlug from "./extra/CreateSlug";

import { driver } from "driver.js";
import "driver.js/dist/driver.css";
import LiveRequest from "./LiveRequest";
import getDecryptData from "../../helper/getDecryptData";


const MenuItem = ({ item }) => {
  return (
    <li key={item.id} className={item.children ? "has_submenu" : ""}>
      {item.children && item.children.length > 0 ? (
        <>
          <span>
            <Link
              to={item.link.replace('{{id}}', (localStorage.getItem('location') !== "[object Object]" && localStorage.getItem('location')) ? localStorage.getItem('location') : "delhi")}
              target={item.target === "_blank" ? "_blank" : ""}
            >
              {item.text}
            </Link>
            <i className="ti ti-chevron-right"></i>
          </span>
          <SubMenu items={item.children} />
        </>
      ) : (
        <Link
          to={item.link.replace('{{id}}', (localStorage.getItem('location') !== "[object Object]" && localStorage.getItem('location')) ? localStorage.getItem('location') : "delhi")}
          target={item.target === "_blank" ? "_blank" : ""}>
          {item.text}
        </Link>
      )}
    </li>
  );
};

const SubMenu = ({ items }) => {
  return (
    <ul className="submenu">
      <li>
        <span className="mobile_menu_back">
          <i className="ti ti-chevron-left"></i> Back
        </span>
      </li>
      {items.map((child) => (
        <MenuItem key={child.id} item={child} />
      ))}
    </ul>
  );
};

const HeaderPage = ({ title }) => {

  const decryptdatajson = getDecryptData();

  const navigate = useNavigate();

  if (navigator.geolocation) {
    navigator.geolocation.getCurrentPosition(
      function (position) {
        const latitude = position.coords.latitude;
        const longitude = position.coords.longitude;

        // Save to localStorage
        localStorage.setItem("userLatitude", latitude);
        localStorage.setItem("userLongitude", longitude);

        console.log("Location saved");
      },
      function (error) {
        console.log("Location error:", error);
      }
    );
  }


  useEffect(() => {
    const location = localStorage.getItem('location');
    if (location !== "[object Object]" && location) {
      // navigate(`/loc/${location}`)
    } else {
      // driverObj.drive();

    }
  }, []);



  const location = useLocation();

  const [user, setUser] = useState(null);

  const [showSearch, setShowSearch] = useState("false");
  const toggleSearch = () => {
    setShowSearch(!showSearch);
  };


  const {
    Headers,
    isHeader,
    cartItems,
    AllProducts,
    AllCategoriess,
    isLayoutLoading,
    LocationHeaders,
    layout,
  } = useBlogContext();
  if (isHeader) {
    // console.log("Headers", Headers);
  }

  const [isOpen, setIsOpen] = useState(false);

  const toggleMenu = () => {
    setIsOpen(!isOpen);
  };

  const closeMenu = () => {
    setIsOpen(false);
  };

  const toggleSubMenu = (event) => {
    const submenu = event.target.nextElementSibling;
    submenu.classList.toggle("open");
  };

  const goBack = (event) => {
    const parentSubMenu = event.target.closest(".submenu");
    parentSubMenu.classList.remove("open");
  };


  useEffect(() => {
    $("#mobile_menu_container").removeClass("open");
    const storedUser = JSON.parse(getCookie("user"));
    setUser(storedUser);
  }, [location.pathname]);

  useEffect(() => {
    window.scrollTo(0, 0);

    $("#mobile_menu_trigger").click(function () {
      $("#mobile_menu_container").toggleClass("open");
    });

    $("#mobile_menu_trigger_mob").click(function () {
      $("#mobile_menu_container").toggleClass("open");
    });

    $("#mobile_menu_container, .mobile_menu_close, .mobile_menu_close i").on(
      "click",
      function (e) {
        if (e.target === this) {
          $("#mobile_menu_container").toggleClass("open");
          /* $('#mobile_menu_container_inner').toggleClass('open'); */
        }
      }
    );

    $(document).on("click", "#mobile_menu .has_submenu > span", function () {
      $("+ .submenu", $(this)).addClass("open");
    });

    $(document).on("click", "#mobile_menu .sub_sub_menu > span", function () {
      $("+ ul", $(this)).addClass("open");
    });

    $(document).on("click", "#mobile_menu .mobile_menu_back", function () {
      $(this).closest("ul").removeClass("open");
    });
  }, []);

  const [searchQuery, setSearchQuery] = useState("");
  const [SearchShow, setSearchShow] = useState(false);
  const handleFocus = () => {
    setSearchShow(true); // Update state when input is focused
  };
  const handleInputChange = (e) => {
    setSearchQuery(e.target.value);
    console.log('e.target.value', e.target.value)
  };

  const handleClearClick = (value) => {


    const locationData = localStorage.getItem('location');
    const locSlug = locationData ? CreateSlug(locationData) : null;

    const currentPath = location.pathname; // e.g., /delhi/anypage
    const pathSegments = currentPath.split('/');

    const locLiveSlug = pathSegments.find(segment => segment.trim()); // finds "gumia"
    const cleanLocLiveSlug = locLiveSlug?.trim(); // final cleaned slug

    console.log('currentPath locSlug ', cleanLocLiveSlug, locSlug, value)
    if (cleanLocLiveSlug === locSlug && (!Array.isArray(value) && typeof value !== 'object' || value === null)) {

      //  Replace the first segment if it's a location
      if (pathSegments.length > 1) {
        pathSegments[1] = CreateSlug(value.toLowerCase()); // set new location
      }
      const updatedPath = pathSegments.join('/');
      console.log('livepath ', updatedPath)

      //  window.location.href = updatedPath;
      navigate(updatedPath)

    } else {
      const fvalue = CreateSlug(value);

      if (fvalue == 'object-object') {
        navigate(`/`)
      } else {
        navigate(`/${CreateSlug(value)}`)
      }
    }


    setSearchQuery("");
    setSearchShow(false);
    if (value) {
      localStorage.setItem('location', value);
    }
  };




  // const filteredLocations = LocationHeaders.filter((zone) => {
  //   // Check if the state name or any of its cities contains the search query
  //   return (
  //     zone.name.toLowerCase().includes(searchQuery.toLowerCase())
  //   );
  // });

  const filteredLocations = LocationHeaders.filter((location) =>
    location.toLowerCase().includes(searchQuery.toLowerCase())
  );

  const [isStuck, setIsStuck] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY > 50) {
        setIsStuck(true);
      } else {
        setIsStuck(false);
      }
    };

    window.addEventListener("scroll", handleScroll);

    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []); // Empty dependency array ensures that this effect runs only once after initial render

  const [isMenuOpen, setIsMenuOpen] = useState(false);

  const handleMenuToggle = () => {
    setIsMenuOpen(!isMenuOpen); // Toggle the value of isMenuOpen
  };

  // const isLogin = useSelector(state => state.isLogin)
  // console.log(isLogin)

  const dispatch = useDispatch();
  //state
  const [value, setValue] = useState();

  // const isLoginFromLocalStorage = localStorage.getItem("token") ? true : false;
  const isLoginFromLocalStorage = getCookie("token") ? true : false;
  const [isLogin, setIsLogin] = useState(isLoginFromLocalStorage);

  useEffect(() => {
    setIsLogin(isLoginFromLocalStorage);
  }, [isLoginFromLocalStorage]);




  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const handleBackClick = () => {
    if (window.history.length > 2) {
      navigate(-1);  // Goes back in history
    } else {
      navigate('/');  // Navigate to the home page if no history
    }
  };

  return (
    <>

      <header className="header py-2 mx-auto border-bottom px-3">
        <div className="header-content py-2 d-flex">
          <div className="left-content d-flex gap-2 align-items-center">

            {/* <button onClick={handleBackClick} className="back-btn border-0">
              <i className="ri-arrow-left-line" />
            </button> */}

            <button onClick={handleBackClick} className="btn btn-sm btn-dark p-2 rounded-pill pe-3">
              <i className="ri-arrow-left-s-line me-1" /> Back
            </button>


            {title.length !== 0 ?
              <h5 className="m-0 text-truncate" style={{ maxWidth: 200 }} >  {title} </h5>
              :
              <div
                className="card-1 skeleton"
                style={{ borderRadius: 5, height: 40, width: 180 }}
              ></div>
            }

          </div>

        </div>
      </header>


    </>
  );
};

export default HeaderPage;
